'use strict';

var standardPayload = function standardPayload(_ref) {
  var config = _ref.config,
    instance = _ref.instance,
    _ref$payload = _ref.payload,
    payload = _ref$payload === void 0 ? {} : _ref$payload;
  // It is possible for the user to change their publisher once they have logged in,
  // so we need to save the publisher and occasionally change it when they switch.
  var publisher_id = instance.storage.getItem('publisherId') || config.publisherId || (payload === null || payload === void 0 ? void 0 : payload.publisher_id);
  var _instance$getState = instance.getState('page'),
    _instance$getState$la = _instance$getState.last,
    _instance$getState$la2 = _instance$getState$la === void 0 ? {} : _instance$getState$la,
    _instance$getState$la3 = _instance$getState$la2.properties,
    pageData = _instance$getState$la3 === void 0 ? {} : _instance$getState$la3;
  var _instance$getState2 = instance.getState('user'),
    userId = _instance$getState2.userId,
    anonymousId = _instance$getState2.anonymousId;
  var _instance$getState3 = instance.getState('context'),
    session_id = _instance$getState3.sessionId,
    locale = _instance$getState3.locale,
    campaign = _instance$getState3.campaign,
    referrer = _instance$getState3.referrer;
  return Object.assign({
    user_id: userId || anonymousId,
    publisher_id: publisher_id
  }, pageData, {
    session_id: session_id,
    locale: locale,
    campaign: campaign,
    referrer: referrer,
    context: config.context
  });
};
var standardPayload$1 = standardPayload;

module.exports = standardPayload$1;
//# sourceMappingURL=index.js.map
